import { isEmpty, isNumber } from "lodash";
import { useState } from "react";
import { useContextSelector } from "use-context-selector";
import BetSlipContext from "../../../context/BetSlipContext";
import { AnimatePresence, motion } from "framer-motion";
import { useTabIndicator } from "../../../components/useTabIndicator";
import { useFancyLogic } from "../../useLogic/useFancyLogic";

const FancyVelkie = ({
  fancy,
  detail,
  profileData,
  position,
  addToFavioute,
  favouriteList,
  fancyHeader,
  setFancyModal,
}) => {
  const [fancyHeaderKey, setFancyHeaderKey] = useState("All");
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });

  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });
  const { data, localLimit, handelChange, mergeAndCalculate } = useFancyLogic({
    fancy,
    detail,
    profileData,
    favouriteList,
    fancyHeaderKey,
  });

  const { containerRef, setActiveIndex, indicatorStyle } = useTabIndicator(0);

  return (
    <>
      {" "}
      <>
        <div
          data-v-7d578f35
          className="flex items-center bg-market-tab-active text-market-tab-text pl-1.5 pt-px"
          style={{
            "--27cc0d26": `${indicatorStyle?.width || 30}px`,
            "--44f3f56a": `translateX(${indicatorStyle?.x || 3}px)`,
          }}
        >
          <div data-v-7d578f35 className="overflow-x-scroll mr-2 -ml-0.5">
            <div data-v-7d578f35 className="relative inline-block">
              <div
                ref={containerRef}
                data-v-7d578f35
                className="w-full h-30px flex jusrify-center"
              >
                {fancyHeader?.map((res, index) => {
                  return (
                    <div
                      onClick={() => {
                        setFancyHeaderKey(res?.type);
                        setActiveIndex(index);
                      }}
                      name={res?.name}
                      data-v-7d578f35
                      className="text-13 font-bold py-2 px-2 mx-1 mt-px text-center"
                    >
                      {res?.name}
                    </div>
                  );
                })}

                <motion.div
                  data-v-7d578f35
                  className="tab-indicator absolute left-0 bottom-1 rounded-full bg-event-tab-num"
                />
              </div>
            </div>
          </div>
          <div
            data-v-7d578f35
            className="icon-info-circle block w-4 h-4 text-market-sub-icon ml-auto mr-2"
          />
        </div>

        <div className="rounded-b-lg">
          {data?.length > 0 ? (
            <div className="pt-1 bg-white rounded-bl-lg rounded-br-lg pb-1">
              <div className="mb-1 flex justify-between items-center">
                <div className="w-9/12" />
                <div className="w-4/12 grid gap-0.5 grid-cols-2">
                  <div className="min-w-min text-10 text-global-font-on-light text-center">
                    No
                  </div>
                  <div className="min-w-min text-10 text-global-font-on-light text-center">
                    Yes
                  </div>
                </div>
              </div>
              <div className="divide-y divide-black-100">
                <div>
                  {data?.map((item, index) => {
                    if (
                      item?.odds?.ms == 4 ||
                      item?.odds?.rt?.length == 0 ||
                      item?.odds?.ms == 2 ||
                      isEmpty(item?.odds?.rt)
                    ) {
                      return null;
                    } else {
                      let findPosition = position?.find((res) => {
                        return res?.selectionId == item?.selectionId;
                      });
                      let oldPosition = !isEmpty(findPosition)
                        ? findPosition?.position
                        : "";

                      let newPosition = "";
                      if (oldPosition && position) {
                        let oldPositionData = findPosition || [];

                        if (
                          betSlipObject?.teamName === item?.name &&
                          showBetDialog
                        ) {
                          betSlipObject.betType = betSlipObject?.object?.ib
                            ? "Yes"
                            : "No";

                          newPosition =
                            oldPositionData && oldPositionData?.betRunPosition
                              ? mergeAndCalculate(
                                betSlipObject,
                                oldPositionData
                              )
                              : 0;
                        }
                      } else {
                        if (
                          betSlipObject?.teamName === item?.name &&
                          showBetDialog
                        ) {
                          if (betSlipObject?.object?.ib) {
                            if (Math.abs(item?.position) > 0) {
                              let backLoss =
                                Number(betSlipObject?.bidPrice) +
                                Number(item?.position);
                              newPosition = backLoss;
                            } else {
                              let backLoss = Number(betSlipObject?.bidPrice);
                              newPosition = backLoss;
                            }
                          } else {
                            if (Math.abs(item?.position) > 0) {
                              let backProfit =
                                (betSlipObject?.bidPrice *
                                  betSlipObject?.object?.pt) /
                                100;
                              newPosition =
                                Number(backProfit) + Number(item.position);
                            } else {
                              let backProfit =
                                (betSlipObject?.bidPrice *
                                  betSlipObject?.object?.pt) /
                                100;
                              newPosition = backProfit;
                            }
                          }
                        }
                      }

                      let condition =
                        betSlipObject?.tamName === item?.name &&
                        Math.abs(newPosition) >= 0;
                      let animate = favouriteList?.includes(
                        String(item?.selectionId)
                      );
                      return (
                        <AnimatePresence>
                          <motion.div
                            key={item.selectionId}
                            layout={animate} // Animate only clicked item
                            initial={animate ? { opacity: 0, y: 5 } : false}
                            animate={animate ? { opacity: 1, y: 0 } : {}}
                            exit={{ opacity: 0 }}
                            transition={{
                              type: "spring",
                              stiffness: 500,
                              damping: 20,
                              mass: 0.5,
                            }}
                            className="mb-1px px-1 relative"
                          >
                            <div className="flex justify-start items-center bg-black-100">
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  addToFavioute(
                                    detail?.eventId,
                                    "Fancy",
                                    item?.selectionId
                                  );
                                }}
                                className="-ml-5px -mr-4px"
                              >
                                <div
                                  data-v-117db823
                                  className="w-8 h-6 flex justify-center items-center"
                                  style={{
                                    "--b64d5fc0": "0.4363636363636363",
                                    "--3cad14f0": "-0.9375rem",
                                  }}
                                >
                                  <div
                                    data-v-117db823
                                    className={`fave ${animate ? "animate" : ""
                                      } bg-star-sprit-black-webp`}
                                  />
                                </div>
                              </div>
                              <div className="w-8/12 h-full text-13 flex flex-col justify-center my-7px px-2">
                                <div className="flex flex-row">
                                  <h2 className="break-words flex-1 leading-5 m-auto">
                                    {item?.name}
                                  </h2>
                                  {!isEmpty(findPosition) && (
                                    <div
                                      onClick={() =>
                                        setFancyModal({
                                          status: true,
                                          object: {
                                            ...item,
                                            match: detail?.eventName,
                                            prevPosition: isNumber(oldPosition),
                                          },
                                        })
                                      }
                                      style={{ background: "#ffc800" }}
                                      className="text-11  font-normal p-5px leading-12px h-min rounded-3px ml-7px"
                                      data-testid="books-btn"
                                    >
                                      <div className="">Book</div>
                                    </div>
                                  )}
                                </div>
                                {(isNumber(oldPosition) || condition) && (
                                  <div
                                    className="text-10 leading-normal flex font-bold"
                                    data-testid="forecast"
                                  >
                                    {" "}
                                    {isNumber(oldPosition) &&
                                      Math.abs(item?.position) > 0 && (
                                        <span className="flex items-center text-error">
                                          {isNumber(oldPosition)
                                            ? `( ${Math?.abs(
                                              item?.position
                                            ).toFixed(2)} )`
                                            : ""}
                                        </span>
                                      )}
                                    {betSlipObject?.teamName === item?.name &&
                                      Math.abs(newPosition) >= 0 && (
                                        <span className="flex items-center text-error">
                                          <div className="icon-arrow-left rotate-180 flex text-6 mx-0.5" />{" "}
                                          {`( ${Math.abs(newPosition).toFixed(
                                            2
                                          )} )`}
                                        </span>
                                      )}
                                  </div>
                                )}
                              </div>
                              <div className="w-4/12 relative grid gap-0.5 grid-cols-2 self-start">
                                <div
                                  title={
                                    item?.odds?.rt?.length > 0
                                      ? item?.odds?.rt[0]?.rt
                                      : ""
                                  }
                                  id={"lay_odds_fancy_" + index}
                                  onClick={(e) => {
                                    {
                                      handelChange(
                                        item?.odds?.rt[0],
                                        "No",
                                        item?.name,
                                        item,
                                        e
                                      );
                                    }
                                  }}
                                  data-v-d52ad534
                                  className={`min-h-full text-center rounded-md bg-lay-300 pt-2 pb-5px ${betSlipObject?.teamName == item?.name &&
                                      betSlipObject?.odds ==
                                      item?.odds?.rt[0]?.rt &&
                                      showBetDialog &&
                                      betSlipObject?.betType == "No"
                                      ? "no-active"
                                      : ""
                                    } ${Number(
                                      document.getElementById(
                                        "lay_odds_fancy_" + index
                                      )?.title
                                    ) !== item?.odds?.rt[0]?.rt
                                      ? "animate-spark-no"
                                      : ""
                                    }`}
                                  betinfoid="4.1757601563164-F2-NO"
                                >
                                  <h3
                                    data-v-d52ad534
                                    className="text-15 leading-12px"
                                  >
                                    {item?.odds?.rt[0]?.rt || ""}
                                  </h3>
                                  <p
                                    data-v-d52ad534
                                    className="text-9 mt-2px h-10px leading-10px"
                                  >
                                    {item?.odds?.rt[0]?.pt || ""}
                                  </p>
                                </div>
                                <div
                                  style={{ height: "36px" }}
                                  title={
                                    item?.odds?.rt?.length > 0
                                      ? item?.odds?.rt[1]?.rt
                                      : ""
                                  }
                                  id={"back_odds_fancy_" + index}
                                  onClick={(e) => {
                                    {
                                      handelChange(
                                        item?.odds?.rt[1],
                                        "Yes",
                                        item?.name,
                                        item,
                                        e
                                      );
                                    }
                                  }}
                                  data-v-d52ad534
                                  className={`min-h-full text-center rounded-md bg-back-300 pt-2 pb-5px ${Number(
                                    document.getElementById(
                                      "back_odds_fancy_" + index
                                    )?.title
                                  ) !== item?.odds?.rt[1]?.rt
                                      ? "animate-spark-yes"
                                      : ""
                                    } ${betSlipObject?.teamName == item?.name &&
                                      betSlipObject?.odds ==
                                      item?.odds?.rt[1]?.rt &&
                                      showBetDialog &&
                                      betSlipObject?.betType == "Yes"
                                      ? "yes-active"
                                      : ""
                                    }`}
                                  betinfoid="4.1757601563164-F2-YES"
                                >
                                  <h3
                                    data-v-d52ad534
                                    className="text-15 leading-12px"
                                  >
                                    {item?.odds?.rt[1]?.rt || ""}
                                  </h3>
                                  <p
                                    data-v-d52ad534
                                    className="text-9 mt-2px h-10px leading-10px"
                                  >
                                    {item?.odds?.rt[1]?.pt || ""}
                                  </p>
                                </div>
                                {(item?.odds?.ms == 9 ||
                                  item?.odds?.ms == 2 ||
                                  item?.odds?.ms == 3 ||
                                  item?.odds?.ms == 4) && (
                                    <div className="absolute right-0 top-0 flex justify-center items-center w-full h-full bg-black-700 opacity-80 text-11 text-white rounded-md">
                                      Suspended
                                    </div>
                                  )}
                              </div>
                            </div>
                          </motion.div>
                        </AnimatePresence>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-white rounded-b-xl">
              <div className="bg-market-tab-active h-3px" />
              <div className="py-3 px-4">Markets Mapping…</div>
            </div>
          )}
        </div>
      </>
    </>
  );
};

export default FancyVelkie;
